import React from 'react';

const Test = (props) => {

    const { children } = props;
    
    return ({children});
}
 
export default Test;